import {
  Col,
  Form,
  Row,
  Modal,
  Button
} from 'react-bootstrap';

import styles from './ValeRefeicao.module.css';

const ValeRefeicao = props => {
  return (
    <div className={styles.container}>
      <Row className={styles.title}>Vale Refeição / Alimentação</Row>
      {!props.isValeRefeicao ? (
        <div className={styles.options}>
          <Row className={styles.subtitle}>Escolha uma das 3 opções abaixo:</Row>
          <Row>
            <Col sm={12}>
              <Form.Check
                className={styles.checkbox}
                type="radio"
                label="100% do valor em Vale Refeição"
                value="100% do valor em Vale Refeição"
                name="valeRefeicao"
                id="valeRefeicao1"
                onChange={e => props.handleValeRefeicao(e)}
                disabled
              />
              <Form.Check
                className={styles.checkbox}
                type="radio"
                label="100% do valor em Vale Alimentação"
                value="100% do valor em Vale Alimentação"
                name="valeRefeicao"
                id="valeRefeicao2"
                onChange={e => props.handleValeRefeicao(e)}
                disabled
              />
              <Form.Check
                className={styles.checkbox}
                type="radio"
                label="50% do valor em Vale Refeição e 50% do valor em Vale Alimentação"
                value="50% do valor em Vale Refeição e 50% do valor em Vale Alimentação"
                name="valeRefeicao"
                id="valeRefeicao3"
                onChange={e => props.handleValeRefeicao(e)}
                disabled
              />
            </Col>
          </Row>
        </div>
      ) : (
          <div className={styles.options}>
            <Row className={styles.subtitle}>A sua opção foi:</Row>
            <Row>
              <Col sm={12}>
                <Form.Check
                  className={styles.checkbox}
                  type="radio"
                  label="100% do valor em Vale Refeição"
                  value="100% do valor em Vale Refeição"
                  name="valeRefeicao"
                  id="valeRefeicao4"
                  disabled
                  checked={props.isValeRefeicao === '100% do valor em Vale Refeição'}
                />
                <Form.Check
                  className={styles.checkbox}
                  type="radio"
                  label="100% do valor em Vale Alimentação"
                  value="100% do valor em Vale Alimentação"
                  name="valeRefeicao"
                  id="valeRefeicao5"
                  disabled
                  checked={props.isValeRefeicao === '100% do valor em Vale Alimentação'}
                />
                <Form.Check
                  className={styles.checkbox}
                  type="radio"
                  label="50% do valor em Vale Refeição e 50% do valor em Vale Alimentação"
                  value="50% do valor em Vale Refeição e 50% do valor em Vale Alimentação"
                  name="valeRefeicao"
                  id="valeRefeicao6"
                  disabled
                  checked={props.isValeRefeicao === '50% do valor em Vale Refeição e 50% do valor em Vale Alimentação'}
                />
              </Col>
            </Row>
          </div>
      )}

      <Modal show={props.showModalVRErro} onHide={props.handleModalVRErroClose}>
        <Modal.Header closeButton>
          <Modal.Title>Erro</Modal.Title>
        </Modal.Header>
        <Modal.Body>A opção para a escolha de VR / VA através do SisGeD está fora do prazo. Favor entrar em contato com gprt@fesaude.niteroi.rj.gov.br para realizar a escolha.</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleModalVRErroClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        contentClassName={styles.modalWidth}
        show={props.showModalVRConfirm}
        onHide={props.handleModalVRConfirmClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Atenção!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Você selecionou a opção:</p>
          <p className={styles.confirm}>{props.vrOption}</p>
          <p>Após confirmar a sua opção só será possível alterá-la depois de 6 meses.</p>
          <p className={styles.confirm}>Deseja confirmar?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleModalVRConfirmClose}>
            Não
          </Button>
          <Button variant="flat" className={styles.btn} onClick={props.vrConfirm}>
            Sim
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ValeRefeicao;
